{
  "it": {
    "meta": {
      "description": "FleetYards.net, il tuo database per tutte le informazioni relative alle navi di “Star Citizen“."
    },
    "model": {
      "focus": "Specializzazione",
      "classification": "Classificazione",
      "size": "Dimensione",
      "beam": "Raggio",
      "cargo": "Carico",
      "personalInventory": "Inventario della nave",
      "crew": "Equipaggio",
      "speed": "Velocità",
      "minCrew": "min. Equipaggio",
      "maxCrew": "max. Equipaggio",
      "scmSpeed": "Velocità SCM",
      "scmSpeedBoosted": "Velocità SCM Potenziata",
      "reverseSpeedBoosted": "Velocità Indietro Potenziata",
      "maxSpeed": "Velocità Massima",
      "scm": "SCM",
      "max": "Max",
      "groundMaxSpeed": "Velocità Massima",
      "groundReverseSpeed": "Velocità Indietro",
      "pitch": "Beccheggio",
      "pitchBoosted": "Beccheggio Potenziato",
      "yaw": "Imbardata",
      "yawBoosted": "Imbardata Potenziata",
      "roll": "Rollio",
      "rollBoosted": "Rollio Potenziato",
      "price": "Prezzo",
      "groundAcceleration": "Accelerazione",
      "compare": {
        "groundMaxSpeed": "Velocità Massima a Terra",
        "groundReverseSpeed": "Velocità Indietro a Terra",
        "groundAcceleration": "Accelerazione a Terra",
        "groundDeceleration": "Decelerazione a Terra"
      },
      "pledgePrice": "Prezzo del Pledge",
      "quantumFuelTankSize": "Carburante Quantum",
      "hydrogenFuelTankSize": "Carburante",
      "height": "Altezza",
      "length": "Lunghezza",
      "mass": "Massa",
      "manufacturer": "Produttore",
      "hardpoints": "Punti di montaggio",
      "weapons": "Armamenti",
      "equipment": "Equipaggiamento",
      "variants": "Varianti",
      "productionStatus": "Stato Della Produzione",
      "propulsion": "Propulsione",
      "modular": "Modulare",
      "soldAt": "Venduto a?",
      "rentalAt": "Noleggiato a?",
      "poweredByUex": "Offerto da UEX",
      "lastUpdatedAt": "Ultimo aggiornamento?"
    },
    "component": {
      "manufacturer": "Produttore",
      "size": "Dimensione"
    },
    "availability": {
      "soldAt": "Venduto a",
      "boughtAt": "Acquistato a"
    },
    "resources": {
      "models": "Navi",
      "hardpoints": "Punti di montaggio",
      "images": "Immagini"
    },
    "pagination": {
      "previous": "Pagina precedente",
      "next": "Pagina successiva",
      "gap": "&hellip;"
    }
  }
}
